/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import { checkSquare } from "react-icons-kit/fa/checkSquare";
import { squareO } from "react-icons-kit/fa/squareO";
import MaterialCheckBox from "@material-ui/core/Checkbox";

export default function Checkbox({ checked, onClick, size = 15 }) {
  return (
    <MaterialCheckBox
      style={{ height: 10, marginBottom: 1 }}
      icon={
        <View style={{ marginBottom: 3, marginLeft: 1 }}>
          <Icon size={size} icon={squareO} />
        </View>
      }
      checkedIcon={
        <View style={{ marginBottom: 3, marginLeft: 1 }}>
          <Icon size={size} icon={checkSquare} />
        </View>
      }
      checked={checked}
      onClick={onClick}
    />
  );
}
